import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AgentFactoryInterface } from '../factories/agent.factory.interface';
import { AgentInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';
import { UserProvider } from '../providers/user.provider';

@Injectable()
export class CreateContractUseCase implements UseCase<Observable<Transaction<void>>> {
    constructor(
        private agentFactory: AgentFactoryInterface,
        private contractProvider: ContractProvider,
        private userProvider: UserProvider
    ) {}

    bind(): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.userProvider.profile().pipe(
                            switchMap((transactionUser) =>
                                transactionUser.map(
                                    (user) => {
                                        const agent: AgentInterface = this.agentFactory.build(user.code);
                                        contract.agent = agent;
                                        contract.holders.map((holder) => {
                                            holder.agent = agent;
                                            holder.legalGuardians.map((legalGuardian) => {
                                                legalGuardian.agent = agent;
                                            });
                                        });
                                        contract.authorized.map((authorized) => {
                                            authorized.agent = agent;
                                        });

                                        return this.contractProvider.create(contract);
                                    },
                                    (throwable) => of(Transaction.error(throwable.message))
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
